export default __webpack_public_path__ + "static/media/cert-general-staff-HKIRC-sc.7bdeeb19.jpg";